import gql from 'graphql-tag';
const AUTHENTICATED_USER = gql`
  mutation authenticatedUser {
    authenticatedUser {
      id
      username
      campaignTableDisplayColumns
      config {
        id
        priceVisible
        providersVisible
        isPartner
        isTrafficker
        isSelfService
        hasInsights
        isAdmin
        exportData
        isProcessor
        canResetPasswords
        campaignSummary
        isPacing
        pastData
        segment
        articles
        amplify
        configurator
        billing
        sitesAppsTransactions
        embeddableConfig {
          type
          ssoToken
          widgetConfig {
            transactionChart
            transactionTable
          }
          campaignOrder {
            id
            name
          }
        }
        isBeta
      }
      email
      cognitoUserId
      roles {
        roleItems {
          feature
          actions
        }
        org {
          id
          name
          cpm
          chatWootId
          level
          zone
          advertiserKnowledgeBaseURL
          config {
            priceVisible
            providersVisible
            isPartner
            isTrafficker
            isSelfService
            hasInsights
            isAdmin
            exportData
            isProcessor
            canResetPasswords
            campaignSummary
            isPacing
            pastData
            segment
            articles
            amplify
            configurator
            billing
            sitesAppsTransactions
          }
          paymentConfig {
            id
            providerId
            paymentProvider
          }
          dataConfig {
            reTargeting
            appIds
            tradeDeskIdentifier
            storageBucket
            googleCustomerId
            roasFormat
            defaultDisplayAttributionWindow
            defaultPaidSearchAttributionWindow
            defaultSEOAttributionWindow
            currency {
              currency
              conversionValue
            }
          }
          platformDomain
          tagDomain
          parentOrg {
            id
            name
            level
            advertiserKnowledgeBaseURL
          }
          logo {
            id
            key
          }
        }
      }
      avatar {
        key
      }
      notifications {
        id
        message
        type
        featureID
      }
      ssoToken
      timezone
    }
  }
`;
export default AUTHENTICATED_USER;
